The date & time the application was accepted from the candidate.

This field has weak ordering guarantees, so it should not be used as a pagination argument.
